export const CHARTIQ_THEME_SET_HELPER = 'chartiqtheme/SET_HELPER';
export const CHARTIQ_THEME_CHANGE_THEME = 'chartiqtheme/CHANGE_THEME';
export const CHARTIQ_THEME_SAVE_THEME = 'chartiqtheme/SAVE_THEME';
export const CHARTIQ_THEME_UPDATE_THEME = 'chartiqtheme/UPDATE_THEME';
export const CHARTIQ_THEME_TOGGLE_THEME_EDITOR = 'chartiqtheme/TOGGLE_THEME_EDITOR';
export const CHARTIQ_THEME_DELETE_THEME = 'chartiqtheme/DELETE_THEME';
export const CHARTIQ_THEME_RESTORE_THEMES = 'chartiqtheme/RESTORE_THEMES';
